import { render } from "./RoundTextSymbol.vue?vue&type=template&id=46520a20&ts=true"
import script from "./RoundTextSymbol.vue?vue&type=script&lang=ts"
export * from "./RoundTextSymbol.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__